var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7.9375mm",
    height: "10.583mm",
    viewBox: "0 0 7.9375 10.583333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-230.38 -320.43)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 648.94 475.83)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-1582-587.31h30v40h-30z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.4574)",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1558.3-555.64q0 0.95703-0.3646 1.8229-0.3646 0.8431-1.0026 1.4811t-1.5039 1.0026q-0.8431 0.36459-1.8002 0.36459h-14.925q-0.957 0-1.8229-0.36459-0.8431-0.36458-1.4811-1.0026t-1.0026-1.4811q-0.3646-0.86589-0.3646-1.8229v-4.1927h4.6712v4.1927h14.925v-9.3197h-14.925q-0.957 0-1.8229-0.36458-0.8431-0.38737-1.4811-1.0026-0.638-0.63802-1.0026-1.4811-0.3646-0.86588-0.3646-1.8229v-9.3424q0-0.95703 0.3646-1.8001 0.3646-0.86589 1.0026-1.4811 0.638-0.63802 1.4811-1.0026 0.8659-0.38737 1.8229-0.38737h14.925q0.9571 0 1.8002 0.38737 0.8659 0.36458 1.5039 1.0026 0.638 0.61523 1.0026 1.4811 0.3646 0.8431 0.3646 1.8001zm-4.6713-13.991v-9.3424h-14.925v9.3424z",
    strokeWidth: "1px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.9798d4fe6ce1b8a041a3a631e6b7de06.svg";
export { ForwardRef as ReactComponent };